/* eslint-disable import/prefer-default-export */
export const roundToNearestTen = (value) => Math.ceil(value / 10) * 10;
